import { Box } from '@mui/material';
import AreaApexChart from 'components/apexChart';
import TabsBlock from 'components/tabsBlock';
import TileHeader from 'components/tileHeader/TileHeader';
import { useState } from 'react';
import { FiLoader } from 'react-icons/fi';
import { useMediaQuery } from 'usehooks-ts';
import { TTotalAppVolumeResponse } from 'views/types/volume';

const dayVariants = [
  { label: 'daily', value: 'daily' },
  { label: 'weekly', value: 'weekly' },
  { label: 'monthly', value: 'monthly' },
  { label: 'allTime', value: 'allTime' },
];

const VolumeWidget = (props: { title: string; data?: TTotalAppVolumeResponse }) => {
  const { title, data } = props;

  const [selectedDay, setSelectedDay] = useState(dayVariants[0].label);
  const [daysTab, setDaysTab] = useState(0);

  const handleChangDays = (_event: any, newValue: number) => {
    setDaysTab(newValue);

    setSelectedDay(dayVariants[newValue].label);
  };

  const handleSelect = (value: string) => {
    setSelectedDay(value);
  };

  const sm = useMediaQuery('(max-width: 768px)');

  const selectedData = data?.[selectedDay as keyof TTotalAppVolumeResponse];

  const totalValue = selectedData
    ? selectedData.reduce((sum, item) => sum + item.value, 0).toFixed(2)
    : '0';

  return (
    <>
      {data ? (
        <AreaApexChart data={selectedData} selectedDay={selectedDay}>
          <Box
            sx={{
              display: 'flex',
              gap: '8px',
              alignItems: 'end',
              justifyContent: { xs: 'space-between', sm: '' },
              overflow: 'visible',
            }}>
            <TileHeader title={title} subtitle={totalValue} />
            <TabsBlock
              value={daysTab}
              handleClick={handleChangDays}
              labels={dayVariants.map((elem) => elem.value)}
              selectedDay={selectedDay}
              handleSelect={handleSelect}
              days={dayVariants}
              isAdaptive={sm}
            />
          </Box>
        </AreaApexChart>
      ) : (
        <div className="flex h-[225px] w-[450px] justify-center items-center">
          <FiLoader size={48} />
        </div>
      )}
    </>
  );
};

export default VolumeWidget;
